import moment from 'moment';
import React from 'react';
import { META } from '../constants/config';
import { dataURItoBlob } from './documentUtil';
import { getLocalStorage } from './storageUtil';

export const MOMENT_DATE_FORMAT = 'MM-DD-YYYY';

export const toUpper = (v, prev) => {
  if (v === prev) {
    return v;
  }
  return v && v.charAt(0).toUpperCase() + v.slice(1);
};

export const isEmpty = (obj) => {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
};

export const checkProperties = (obj) => {
  for (var key in obj) {
    if (obj[key] !== null && obj[key] !== '') return false;
  }
  return true;
};

export const stringExplode = (str, delimiter) => {
  return str.split(delimiter);
};

export const deepCheckEmptyArray = (obj) => {
  // catch null or undefined object
  if (!obj) return true;
  if (typeof obj === 'object') {
    for (const entry of Object.values(obj)) {
      if (!deepCheckEmptyArray(entry)) {
        return false;
      }
    }
    return true;
  }
  // if input is not an object return false
  return false;
};

export const isDuplicate = (array, title) => {
  return array.some((el) => el.title === title);
};

export const objectCompare = (obj1, obj2) => {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
};

export const allowOnlyNumber = (evt) => {
  let charCode = evt.which ? evt.which : evt.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    evt.preventDefault();
    return false;
  }
  return true;
};

export const allowOnlyNumberDecimal = (evt) => {
  let charCode = evt.which ? evt.which : evt.keyCode;
  if (charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
    evt.preventDefault();
    return false;
  }
  return true;
};

export const allowOnlyPhoneNumber = (evt) => {
  let charCode = evt.which ? evt.which : evt.keyCode;
  if (
    charCode !== 46 &&
    charCode !== 45 &&
    charCode > 31 &&
    (charCode < 48 || (charCode > 57 && charCode !== 64 && charCode !== 95))
  ) {
    evt.preventDefault();
    return false;
  }
  return true;
};
export const notAllowSpace = (evt) => {
  if (evt.which === 32) {
    evt.preventDefault();
    return false;
  }
  return true;
};

export const formikHandleChange = (event, setFieldValue, setBtnClass) => {
  if (event?.target?.id) {
    const targetValue =
      event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    if (targetValue) {
      setBtnClass('btn-green');
    } else {
      setBtnClass('btn-white');
    }
    setFieldValue(event.target.id, targetValue ? targetValue : '');
  }
};

export const handleSelectedIcon = (size, tabName, selectedTab, status) => {
  let iconClassName = `rounded-card ${size} rounded-circle`;
  if (selectedTab) {
    if (tabName === selectedTab) {
      return [iconClassName + ' white-round', 'selected'];
    }
  }
  if (status === 'COMPLETE') {
    return [iconClassName + ' green-round', status];
  } else {
    return [iconClassName + ' red-round', status];
  }
};

export const convertObjectToArray = (obj) => {
  const data = Object.values(obj);
  return data.map((sweetItem) => {
    return sweetItem.toString();
  });
};

export const convertToMomentDate = (array) => {
  array &&
    array.forEach((field, index) => {
      if (moment.isMoment(field.value)) {
        array[index].value = moment(field.value).format(MOMENT_DATE_FORMAT);
      } else {
        array[index].value =
          field.value !== '' || field.value !== undefined || field.value !== null
            ? field.value
              ? field.value.toString()
              : ''
            : field.value;
      }
    });
  return array;
};

export const formatNepaliDate = (dateValue) => {
  let month = dateValue.split('-')[1];
  let day = dateValue.split('-')[2];
  let formattedMonth = '';
  let formattedDay = '';

  if (month.length < 2) {
    formattedMonth = `0${month}`;
  } else {
    formattedMonth = month;
  }
  if (day.length < 2) {
    formattedDay = `0${day}`;
  } else {
    formattedDay = day;
  }
  let formattedDate = `${dateValue.split('-')[0]}-${formattedMonth}-${formattedDay}`;

  return formattedDate;
};

// used for safari not supporting date.
export const formatDateToYYYYMMDD = (targetDate, delim = '-') => {
  if (typeof targetDate === 'string') {
    const targetValue = targetDate.split('-');
    let formattedDate = `${targetValue[2]}`.length === 1 ? `0${targetValue[2]}` : targetValue[2];
    let formattedMonth = `${targetValue[1]}`.length === 1 ? `0${targetValue[1]}` : targetValue[1];
    return `${targetValue[0]}${delim}${formattedMonth}${delim}${formattedDate}`;
  }
};

export const getOptions = (options, listName) => {
  return (
    options &&
    options
      ?.filter((item) => item?.item && item?.item === listName)
      ?.slice(-1)?.[0]
      ?.data.map(
        (item, index) =>
          // <option key={index} value={item.code}>
          //   {item.title}
          // </option>
          item
      )
  );
};

export const capitalizeFirstLetter = (str) => {
  return str?.charAt(0)?.toUpperCase() + str?.slice(1);
};

export const splitCamelCase = (str) => {
  return str?.replace(/([a-z])([A-Z0-9])/g, '$1 $2');
};

export const createIdTypeName = (words) => {
  return words
    ?.toLowerCase()
    ?.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter?.toUpperCase())
    ?.replace(/\s/g, '');
};
export const createIdTypeLabel = (words) => {
  return words?.toLowerCase()?.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter?.toUpperCase());
};

export const metaReplacer = (data, optionName) => {
  const meta = getLocalStorage(META);
  let value = meta?.find(
    (singleObj) =>
      singleObj?.code?.trim()?.toLowerCase() === data?.toLowerCase()?.trim() &&
      singleObj?.category?.trim()?.toLowerCase() === optionName?.trim()?.toLowerCase()
  );
  if (value) return value.title;
  return data;
};

export const getGenderInfo = (data) => {
  let genderData = { m: 'Male', f: 'Female', o: 'Other' };
  if (!genderData[data?.toLowerCase()]) return data;
  return genderData[data?.toLowerCase()];
};

export const getUsResidentsData = (data) => {
  let residentValue = {
    green_card: 'Green Card Holder',
    resident: 'Resident',
    non_resident: 'Non Resident',
    none: 'No',
  };
  if (!residentValue[data]) return 'No';
  return residentValue[data];
};

export const getCurrencyDetail = (data) => {
  let csvCurrencyData;
  const currencyData = data?.some((obj) => obj?.currencyType?.toLowerCase() === 'npr');
  if ((!currencyData && data?.length >= 0) || (currencyData && data?.length >= 0)) {
    const AllCurrencyInfo = data.map((obj) => metaReplacer(obj?.currencyType, 'currencyList'));
    csvCurrencyData = AllCurrencyInfo?.join();
    return { csvCurrencyData, currencyData };
  }
};

export const getEmployeeWith = (data) => {
  let employeeWithData = {
    nepal_gov: 'NEPAL GOVERMENT',
    pub_ltd: 'PUBLIC LIMITED',
    pvt_ltd: 'PRIVATE LIMITED',
  };
  if (!employeeWithData[data]) return data;
  return employeeWithData[data];
};

export const getSelfEmployed = (data) => {
  let self_employed_with = {
    business_man: 'BUSINESS MAN',
    ca: 'CA',
    doctor: 'DOCTOR',
    engineer: 'ENGINEER',
    lawyer: 'LAWYER',
  };
  if (!self_employed_with[data]) return data;
  return self_employed_with[data];
};

export const containsDocument = (docName, documentList) => {
  return documentList?.some((doc) => doc?.documentName === docName);
};

export const containsRelation = (relation, relationList) => {
  return relationList?.some((rel) => rel?.relationship === relation);
};
export const containsIdentity = (identityType, identityList) => {
  return identityList?.some((id) => id?.idType === identityType);
};

export const documentValueIfExists = (documentObject, documentName) => {
  return !isEmpty(
    documentObject?.find((document) => document?.documentName === documentName)?.value
  )
    ? dataURItoBlob(
        // `data:image/png;base64,
        `${documentObject?.find((document) => document?.documentName === documentName)?.value}`,
        documentName
      )
    : undefined;
};

export const isDocumentCompleted = (docArray) => {
  if (docArray?.length === 0) return false;
  let undefinedDocuments = [];
  let mapping = docArray?.forEach((doc) => {
    if (!doc?.value) {
      undefinedDocuments.push(doc?.documentName);
    }
  });
  return undefinedDocuments?.length > 0 ? false : true;
};

export const isFamilyDetailsCompleted = (familyArray) => {
  if (familyArray?.length === 0) return false;
  let nonFilledFamilyName = [];
  let mapping = familyArray?.forEach((rel) => {
    if (!rel?.fullName) {
      nonFilledFamilyName.push(rel?.relationship);
    }
  });
  return nonFilledFamilyName?.length > 0 ? false : true;
};

export const isImage = (base64String) => {
  let mimeString = base64String?.split(',')?.[0]?.split(':')?.[1]?.split(';')?.[0];
  if (['image/jpg', 'image/jpeg', 'image/png']?.includes(mimeString)) return true;
  return false;
};
